import { useEffect, useState } from 'react'
import { Camera, Mic } from 'lucide-react'

export default function DevicePickers({ client, status, className = '' }) {
  const [cams, setCams] = useState([])
  const [mics, setMics] = useState([])
  const [selectedCamId, setSelectedCamId] = useState('')
  const [selectedMicId, setSelectedMicId] = useState('')

  useEffect(() => {
    if (!client) return
    let cancelled = false
    const refresh = async () => {
      try {
        const [allCams, allMics] = await Promise.all([
          client.getAllCams?.() || [],
          client.getAllMics?.() || [],
        ])
        if (cancelled) return
        setCams(allCams.filter((d) => d.deviceId))
        setMics(allMics.filter((d) => d.deviceId))
        setSelectedCamId(client.selectedCam?.deviceId || '')
        setSelectedMicId(client.selectedMic?.deviceId || '')
      } catch {
        /* devices not available yet */
      }
    }
    refresh()
    const handler = () => refresh()
    if (typeof navigator !== 'undefined' && navigator.mediaDevices?.addEventListener) {
      navigator.mediaDevices.addEventListener('devicechange', handler)
    }
    return () => {
      cancelled = true
      if (typeof navigator !== 'undefined' && navigator.mediaDevices?.removeEventListener) {
        navigator.mediaDevices.removeEventListener('devicechange', handler)
      }
    }
  }, [client, status])

  if (!client || (cams.length === 0 && mics.length === 0)) return null

  const onCamChange = (e) => {
    const id = e.target.value
    setSelectedCamId(id)
    try { client.updateCam(id) } catch (err) { console.warn('updateCam failed:', err) }
  }
  const onMicChange = (e) => {
    const id = e.target.value
    setSelectedMicId(id)
    try { client.updateMic(id) } catch (err) { console.warn('updateMic failed:', err) }
  }

  return (
    <div className={`flex flex-col gap-2 text-sm ${className}`}>
      {cams.length > 0 && (
        <label className="flex items-center gap-2">
          <Camera className="size-4 shrink-0 text-muted-foreground" />
          <select
            value={selectedCamId}
            onChange={onCamChange}
            className="min-w-0 flex-1 truncate rounded-md border bg-background px-2 py-1 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-sky-300"
            title="Camera"
          >
            {cams.map((d) => (
              <option key={d.deviceId} value={d.deviceId}>
                {d.label || `Camera ${d.deviceId.slice(0, 6)}`}
              </option>
            ))}
          </select>
        </label>
      )}
      {mics.length > 0 && (
        <label className="flex items-center gap-2">
          <Mic className="size-4 shrink-0 text-muted-foreground" />
          <select
            value={selectedMicId}
            onChange={onMicChange}
            className="min-w-0 flex-1 truncate rounded-md border bg-background px-2 py-1 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-sky-300"
            title="Microphone"
          >
            {mics.map((d) => (
              <option key={d.deviceId} value={d.deviceId}>
                {d.label || `Mic ${d.deviceId.slice(0, 6)}`}
              </option>
            ))}
          </select>
        </label>
      )}
    </div>
  )
}
